import React from 'react';
import styled from 'styled-components';

const AboutContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 6rem 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 3rem;
  text-align: center;
  position: relative;
  
  &::after {
    content: '';
    display: block;
    width: 50px;
    height: 3px;
    background-color: var(--secondary-color);
    margin: 0.5rem auto 0;
  }
`;

const AboutContent = styled.div`
  display: flex;
  gap: 4rem;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

const AboutImageContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AboutImage = styled.div`
  width: 280px;
  height: 320px;
  border-radius: 22px;
  background-color: var(--white);
  overflow: hidden;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-md);
  display: flex;
  justify-content: center;
  align-items: center;
  
  @media (max-width: 768px) {
    width: 220px;
    height: 250px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const AboutTextContent = styled.div`
  flex: 1;
`;

const AboutText = styled.p`
  font-size: 1.05rem;
  margin-bottom: 1.5rem;
  line-height: 1.75;
  color: var(--text-color);
`;

const AboutHighlight = styled.span`
  color: var(--secondary-color);
  font-weight: 600;
`;

const AboutList = styled.ul`
  list-style-type: none;
  margin: 1.5rem 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const AboutListItem = styled.li`
  position: relative;
  padding-left: 1.5rem;
  font-size: 0.975rem;
  
  &::before {
    content: '▹';
    position: absolute;
    left: 0;
    color: var(--secondary-color);
  }
`;

const About = () => {
  return (
    <AboutContainer>
      <SectionTitle>About Me</SectionTitle>
      
      <AboutContent>
        <AboutImageContainer>
          <AboutImage>
            <img src="/myphoto.png" alt="Sultan Malik portrait" />
          </AboutImage>
        </AboutImageContainer>
        
        <AboutTextContent>
          <AboutText>
            Hi, I'm Sultan — a Java fullstack engineer based in <AboutHighlight>Dubai, UAE</AboutHighlight> with {new Date().getFullYear() - 2022}+ years of professional experience building enterprise software. I completed my B.E. in Computer Engineering from M.H. Saboo Siddik College of Engineering, Mumbai, graduating with an 8.6 CGPA.
          </AboutText>
          
          <AboutText>
            I've worked across <AboutHighlight>banking, fintech, and e-invoicing</AboutHighlight> domains — from developing loan origination systems and KYC platforms at Newgen Software to building FTA-compliant e-invoicing SDKs used by 20+ enterprise clients at Marmin Ai. I care deeply about clean architecture, API design, and writing code that is easy to maintain and scale.
          </AboutText>
          
          <AboutText>
            Here are some of the technologies I work with:
          </AboutText>
          
          <AboutList>
            <AboutListItem>Java &amp; Spring Boot</AboutListItem>
            <AboutListItem>Python &amp; Fast API</AboutListItem>
            <AboutListItem>JavaScript / HTML / CSS</AboutListItem>
            <AboutListItem>Oracle SQL &amp; PostgreSQL</AboutListItem>
            <AboutListItem>Docker &amp; AWS</AboutListItem>
            <AboutListItem>RabbitMQ &amp; Redis</AboutListItem>
            <AboutListItem>Flutter &amp; Firebase</AboutListItem>
            <AboutListItem>REST &amp; SOAP APIs</AboutListItem>
          </AboutList>
        </AboutTextContent>
      </AboutContent>
    </AboutContainer>
  );
};

export default About;
